const appHost = process.env.REACT_APP_HOST;
const backendHost = process.env.REACT_APP_BACKEND_HOST;

const CONFIG = {
    appHost,
    backendHost,
    apiUrl: backendHost + 'core/ajax/',
    adminApiUrl: backendHost + 'core/ajax/admin/',
    // Graphic config
    drawerWidth: '240px'
}


export default CONFIG;